import "../../styles/ServicesSlider.css";
import { Container } from "react-bootstrap";
import { Navigation, Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "react-bootstrap/Card";
import { useGetServicesQuery } from "../../redux/features/home/homeApiSlice";
import { BASE_URL } from "../../redux/api/apiSlice";

function Services() {
   // ################### RTK QUERY ###################
   const { data: services, isSuccess, isLoading } = useGetServicesQuery();

   // ################### CONTENT ###################
   let content;
   if (isSuccess && services?.data?.length > 0) {
      content = services?.data?.map((service, i) => (
         <SwiperSlide key={i}>
            <Card className="cardComp" key={service?.Title}>
               <Card.Body>
                  <div className="card-icon">
                     <div className="circle-gradient">
                        <div className="white-circle"></div>
                     </div>
                     <div className="card-icon">
                        <img
                           src={`${BASE_URL}/${service?.Image}`}
                           alt="Service-Icon"
                        />
                     </div>
                  </div>
                  <Card.Title
                     style={{ fontSize: "18px" }}
                     className="cardtitle"
                  >
                     {service?.Title}
                  </Card.Title>
                  <Card.Text className="card-text">
                     {service?.Description}
                  </Card.Text>
               </Card.Body>
            </Card>
         </SwiperSlide>
      ));
   } else if (!isLoading) {
      content = <p className="soon">هنالك خطأ ما، الرجاء المحاولة لاحقا.</p>;
   }

   return (
      <section className="services" id="services">
         <Container>
            <h6 className="section-title">خدماتنا</h6>
            <p className="section-sub-title">
               نقدم أفضل الخدمات في إدارة المشاريع و غيرها
            </p>
            <div className="servicesSlider">
               <Swiper
                  modules={[Navigation, Pagination, A11y]}
                  spaceBetween={20}
                  navigation
                  pagination={{ clickable: true }}
                  scrollbar={{ draggable: true }}
                  breakpoints={{
                     640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                     },
                     768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                     },
                     1024: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                     },
                  }}
               >
                  {content}

                  <br />
                  <br />
                  <br />
               </Swiper>
            </div>
         </Container>
      </section>
   );
}

export default Services;
